import { render, staticRenderFns } from "./FormTel.vue?vue&type=template&id=03f64b7f&"
import script from "./FormTel.vue?vue&type=script&lang=ts&"
export * from "./FormTel.vue?vue&type=script&lang=ts&"
import style0 from "./FormTel.vue?vue&type=style&index=0&id=03f64b7f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f64b7f')) {
      api.createRecord('03f64b7f', component.options)
    } else {
      api.reload('03f64b7f', component.options)
    }
    module.hot.accept("./FormTel.vue?vue&type=template&id=03f64b7f&", function () {
      api.rerender('03f64b7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormTel.vue"
export default component.exports